import React, { memo } from 'react';
import Text from '../../../typography/Text';
const PostComponent = _ref => {
  let {
    count,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Text, props, "+", count);
};
export default /*#__PURE__*/memo(PostComponent);